export const lightThemeViewStyle = [
  // Background and Labels
  {
    elementType: "geometry",
    stylers: [{ color: "#f8f8f8" }], // Light background
  },
  {
    elementType: "labels.text.fill",
    stylers: [{ color: "#333333" }], // Darker text for readability
  },
  {
    elementType: "labels.text.stroke",
    stylers: [{ color: "#ffffff" }], // White stroke for contrast
  },

  // Administrative Boundaries
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [{ color: "#cccccc" }], // Light gray boundaries
  },
  {
    featureType: "administrative.country",
    elementType: "labels.text.fill",
    stylers: [{ color: "#4285f4" }], // Blue for country labels
  },
  {
    featureType: "administrative.land_parcel",
    stylers: [{ visibility: "off" }], // Hide land parcels
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: "#444444" }], // Darker locality labels
  },
  {
    featureType: "administrative.province",
    elementType: "labels.text.fill",
    stylers: [{ color: "#616161" }], // Medium gray for province labels
  },

  // Points of Interest (POI)
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#666666" }], // Medium gray POI labels
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{ color: "#e8e8e8" }], // Light POI background
  },
  {
    featureType: "poi.attraction",
    elementType: "labels.text.fill",
    stylers: [{ color: "#ff5722" }], // Orange-red for attractions
  },
  {
    featureType: "poi.business",
    stylers: [{ visibility: "off" }], // Hide business POIs
  },
  {
    featureType: "poi.government",
    elementType: "labels.text.fill",
    stylers: [{ color: "#ffc107" }], // Yellow for government
  },
  {
    featureType: "poi.medical",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d32f2f" }], // Red for medical
  },
  {
    featureType: "poi.place_of_worship",
    elementType: "labels.text.fill",
    stylers: [{ color: "#795548" }], // Brown for places of worship
  },
  {
    featureType: "poi.school",
    elementType: "labels.text.fill",
    stylers: [{ color: "#1976d2" }], // Blue for schools
  },
  {
    featureType: "poi.sports_complex",
    elementType: "labels.text.fill",
    stylers: [{ color: "#00897b" }], // Teal for sports complexes
  },

  // Parks and Natural Features
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#a5d6a7" }], // Light green parks
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [{ color: "#689f38" }], // Darker green park labels
  },
  {
    featureType: "landscape.natural",
    elementType: "geometry",
    stylers: [{ color: "#e0f2e0" }], // Light natural areas
  },
  {
    featureType: "landscape.man_made",
    elementType: "geometry",
    stylers: [{ color: "#dddddd" }], // Light gray for artificial landscapes
  },

  // Roads
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#ffffff" }], // White roads
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{ color: "#eeeeee" }], // Light gray arterials
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#f0f0f0" }], // Slightly darker highways
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "geometry",
    stylers: [{ color: "#e8e8e8" }], // Controlled access highways
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [{ color: "#757575" }], // Local road labels
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [{ color: "#f9f9f9" }], // Light background for local roads
  },

  // Transit
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{ color: "#f0f0f0" }], // Light transit areas
  },
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [{ color: "#ff1744" }], // Red for transit lines
  },
  {
    featureType: "transit.station",
    elementType: "labels.text.fill",
    stylers: [{ color: "#000000" }], // Black transit station labels
  },
  {
    featureType: "transit.station.bus",
    elementType: "labels.text.fill",
    stylers: [{ color: "#ff9800" }], // Orange for bus stations
  },
  {
    featureType: "transit.station.rail",
    elementType: "labels.text.fill",
    stylers: [{ color: "#673ab7" }], // Purple for rail stations
  },

  // Water Bodies
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#a8c9fa" }], // Light blue water
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#808080" }], // Gray water labels
  },
];

export const darkThemeViewStyle = [
  // Background and Labels
  {
    elementType: "geometry",
    stylers: [{ color: "#1d1d1d" }], // Dark base color
  },
  {
    elementType: "labels.text.fill",
    stylers: [{ color: "#a1a1a1" }], // Light grey for readability
  },
  {
    elementType: "labels.text.stroke",
    stylers: [{ color: "#1d1d1d" }], // Blended stroke for smooth appearance
  },

  // Administrative Boundaries
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [{ color: "#444444" }], // Subtle lines for city/state boundaries
  },
  {
    featureType: "administrative.country",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d4af37" }], // Gold-colored country labels
  },
  {
    featureType: "administrative.land_parcel",
    stylers: [{ visibility: "off" }], // Hide land parcel boundaries for a clean look
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: "#d9d9d9" }], // Brighter city/town names
  },

  // Points of Interest (POI)
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#bdbdbd" }], // Labels for points of interest
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{ color: "#282828" }], // Background for POIs
  },
  {
    featureType: "poi.attraction",
    elementType: "labels.text.fill",
    stylers: [{ color: "#ff9800" }], // Attractions highlighted in orange
  },
  {
    featureType: "poi.business",
    stylers: [{ visibility: "off" }], // Hide business POIs for clarity
  },
  {
    featureType: "poi.medical",
    elementType: "labels.text.fill",
    stylers: [{ color: "#e53935" }], // Hospitals in red
  },
  {
    featureType: "poi.government",
    elementType: "labels.text.fill",
    stylers: [{ color: "#ffeb3b" }], // Government buildings in yellow
  },
  {
    featureType: "poi.school",
    elementType: "labels.text.fill",
    stylers: [{ color: "#03a9f4" }], // Schools in blue
  },

  // Parks and Natural Features
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#16321e" }], // Dark green parks
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [{ color: "#6b9b67" }], // Labels with a muted green
  },
  {
    featureType: "landscape.natural",
    elementType: "geometry",
    stylers: [{ color: "#1e1e1e" }], // General dark natural areas
  },

  // Roads
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#3b3b3b" }], // Dark gray for roads
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{ color: "#4a4a4a" }], // Slightly lighter for major roads
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#585858" }], // Highways slightly brighter
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "geometry",
    stylers: [{ color: "#6a6a6a" }], // Differentiating highways with controlled access
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9e9e9e" }], // Local road labels
  },

  // Transit
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{ color: "#333333" }], // Transit areas darker
  },
  {
    featureType: "transit.line",
    elementType: "geometry",
    stylers: [{ color: "#ff6347" }], // Highlight subway/train lines in red
  },
  {
    featureType: "transit.station",
    elementType: "labels.text.fill",
    stylers: [{ color: "#ffffff" }], // Bright white transit station labels
  },

  // Water Bodies
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#121a2a" }], // Deep blue for water
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#808080" }], // Subtle water labels
  },
];

export const darkThemeMapStyle = [
  {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#1e242b",
      },
      {
        lightness: "5",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#1e242b",
      },
      {
        saturation: "0",
      },
      {
        lightness: "30",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "labels",
    stylers: [
      {
        color: "#1e242b",
      },
      {
        lightness: "30",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "labels.text.stroke",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "administrative.province",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#1e242b",
      },
      {
        lightness: "20",
      },
      {
        weight: "1.00",
      },
    ],
  },
  {
    featureType: "administrative.neighborhood",
    elementType: "labels.text.fill",
    stylers: [
      {
        lightness: "-20",
      },
    ],
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "labels.text.fill",
    stylers: [
      {
        lightness: "-20",
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [
      {
        color: "#1e242b",
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "labels",
    stylers: [
      {
        color: "#1e242b",
      },
      {
        lightness: "30",
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "labels.text.stroke",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        color: "#1e242b",
      },
      {
        lightness: "5",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [
      {
        color: "#1e242b",
      },
      {
        lightness: "30",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text.stroke",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry",
    stylers: [
      {
        visibility: "simplified",
      },
      {
        color: "#1e242b",
      },
      {
        lightness: "15",
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [
      {
        color: "#1e242b",
      },
      {
        lightness: "6",
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "labels",
    stylers: [
      {
        color: "#1e242b",
      },
      {
        lightness: "30",
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "labels.text.stroke",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#010306",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "labels.text.stroke",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
];
export const defaultViewStyle = [
  // Base Map Elements
  {
    elementType: "geometry",
    stylers: [{ color: "#212121" }],
  },
  {
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
  {
    elementType: "labels.text.fill",
    stylers: [{ color: "#757575" }],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [{ color: "#212121" }],
  },

  // **Administrative Boundaries**
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [{ color: "#757575" }],
  },
  {
    featureType: "administrative.country",
    elementType: "labels.text.fill",
    stylers: [{ color: "#9e9e9e" }],
  },
  {
    featureType: "administrative.province",
    elementType: "labels.text.fill",
    stylers: [{ color: "#cfcfcf" }],
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [{ color: "#bdbdbd" }],
  },
  {
    featureType: "administrative.neighborhood",
    elementType: "labels.text.fill",
    stylers: [{ color: "#a0a0a0" }],
  },
  {
    featureType: "administrative.land_parcel",
    stylers: [{ visibility: "off" }],
  },

  // **Points of Interest (POI)**
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{ color: "#2e2e2e" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#757575" }],
  },
  {
    featureType: "poi.business",
    elementType: "labels.text.fill",
    stylers: [{ color: "#a0a0a0" }],
  },
  {
    featureType: "poi.government",
    elementType: "labels.text.fill",
    stylers: [{ color: "#ffcc00" }],
  },
  {
    featureType: "poi.medical",
    elementType: "geometry",
    stylers: [{ color: "#b71c1c" }],
  },
  {
    featureType: "poi.school",
    elementType: "geometry",
    stylers: [{ color: "#282828" }],
  },
  {
    featureType: "poi.place_of_worship",
    elementType: "geometry",
    stylers: [{ color: "#6d4c41" }],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [{ color: "#181818" }],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [{ color: "#616161" }],
  },

  // **Natural Features**
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [{ color: "#181818" }],
  },
  {
    featureType: "landscape.natural",
    elementType: "geometry.fill",
    stylers: [{ color: "#333333" }],
  },
  {
    featureType: "landscape.man_made",
    elementType: "geometry.fill",
    stylers: [{ color: "#2b2b2b" }],
  },

  // **Roads**
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [{ color: "#2c2c2c" }],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#8a8a8a" }],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [{ color: "#373737" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#3c3c3c" }],
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "geometry",
    stylers: [{ color: "#4e4e4e" }],
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [{ color: "#616161" }],
  },

  // **Transit**
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [{ color: "#282828" }],
  },
  {
    featureType: "transit.line",
    elementType: "geometry.fill",
    stylers: [{ color: "#ff3c3c" }],
  },
  {
    featureType: "transit.station",
    elementType: "labels.text.fill",
    stylers: [{ color: "#757575" }],
  },
  {
    featureType: "transit.station.bus",
    elementType: "geometry",
    stylers: [{ color: "#ff9800" }],
  },
  {
    featureType: "transit.station.rail",
    elementType: "geometry",
    stylers: [{ color: "#4a4a4a" }],
  },

  // **Water Bodies**
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#000000" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#3d3d3d" }],
  },
];
export const defaultMapStyle2 = [
  {
    featureType: "all",
    elementType: "labels.text",
    stylers: [
      {
        color: "#878787",
      },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.text.stroke",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "all",
    stylers: [
      {
        color: "#f9f5ed",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "all",
    stylers: [
      {
        color: "#f5f5f5",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#c9c9c9",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [
      {
        color: "#aee0f4",
      },
    ],
  },
];
export const defaultMapStyle = [
  {
    featureType: "landscape",
    stylers: [
      {
        hue: "#FFBB00",
      },
      {
        saturation: 43.400000000000006,
      },
      {
        lightness: 37.599999999999994,
      },
      {
        gamma: 1,
      },
    ],
  },
  {
    featureType: "road.highway",
    stylers: [
      {
        hue: "#FFC200",
      },
      {
        saturation: -61.8,
      },
      {
        lightness: 45.599999999999994,
      },
      {
        gamma: 1,
      },
    ],
  },
  {
    featureType: "road.arterial",
    stylers: [
      {
        hue: "#FF0300",
      },
      {
        saturation: -100,
      },
      {
        lightness: 51.19999999999999,
      },
      {
        gamma: 1,
      },
    ],
  },
  {
    featureType: "road.local",
    stylers: [
      {
        hue: "#FF0300",
      },
      {
        saturation: -100,
      },
      {
        lightness: 52,
      },
      {
        gamma: 1,
      },
    ],
  },
  {
    featureType: "water",
    stylers: [
      {
        hue: "#0078FF",
      },
      {
        saturation: -13.200000000000003,
      },
      {
        lightness: 2.4000000000000057,
      },
      {
        gamma: 1,
      },
    ],
  },
  {
    featureType: "poi",
    stylers: [
      {
        hue: "#00FF6A",
      },
      {
        saturation: -1.0989010989011234,
      },
      {
        lightness: 11.200000000000017,
      },
      {
        gamma: 1,
      },
    ],
  },
];
export default defaultViewStyle;

// Convert dynamic map style array into static map style query string parameters.
export const getStaticMapStyleParams = (styles) => {
  return styles
    .map((styleRule) => {
      let parts = [];

      // Add feature type if provided.
      if (styleRule?.featureType) {
        parts.push(`feature:${styleRule?.featureType}`);
      }

      // Optionally, you could support elementType:
      if (styleRule?.elementType) {
        parts.push(`element:${styleRule.elementType}`);
      }

      // Process each styler.
      styleRule?.stylers?.forEach((styler) => {
        for (let key in styler) {
          let value = styler[key];
          // Convert hue from "#FFBB00" to "0xFFBB00"
          if (key === "hue" && typeof value === "string") {
            value = "0x" + value.replace("#", "");
          }
          parts.push(`${key}:${value}`);
        }
      });

      // Join each rule with the pipe separator.
      return `style=${parts.join("|")}`;
    })
    .join("&");
};
